import {Component, OnInit, Renderer2, ChangeDetectorRef} from '@angular/core';
import { BaseGridEditLineComponent } from '../../shared/base-components/base-grid-editline.component';
import { GlobalsService } from '../../shared/services/globals.service';
import { InventoryService } from '../../shared/services/inventory.service';
import { SaveMode } from '../../shared/enums/SaveMode';
import { v_InventoryBus } from '../../shared/models/v_InventoryBus';

import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InventoryConsMatchesBus } from '../../shared/models/InventoryConsMatchesBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cp-inventory-cons-matches',
    templateUrl: './inventory-cons-matches.component.html',
    styleUrls: ['./inventory-cons-matches.component.scss'],
    standalone: false
})
export class InventoryConsMatchesComponent extends BaseGridEditLineComponent<InventoryConsMatchesBus, null, InventoryService> {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "InventoryConsMatchesBus";
        this.appCode = "InventoryConsMatches";
        this.saveMode = SaveMode.all;
        this.disableCpSearchDialog();
    }

    override ngOnInit() {
        super.ngOnInit();
    }

    setForm() {
        this.editForm.patchValue({
            inventoryConsMatchesId: this.selectedData.inventoryConsMatchesId,
            term: this.selectedData.term ?? "",
            consumableId: this._parentId,
        });
    }
    createForm1() {
        this.editForm = new UntypedFormGroup({

        });

    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'inventoryConsMatchesId': new UntypedFormControl(),
            'term': new UntypedFormControl(),
            'consumableId': new UntypedFormControl(),
        });

    }
    //public addHandler(): void {
    //    this.createForm();
    //    this.grid.addRow(this.editForm);

    //}
}
